import { CORES_DO_STATUS, type StatusEquipamento } from '@/lib/dominio';

/**
 * Selo de status (v2.1, p.24).
 *
 * Duas decisoes que vem do manual e nao sao estilo:
 *  - O ROTULO ESCRITO e obrigatorio. Cerca de 8% dos homens tem deficiencia na
 *    percepcao de vermelho e verde; em obra isso nao e desprezivel. Cor sozinha
 *    nao informa nada.
 *  - SELO PREENCHIDO, com ponto: fundo na tinta do status, ponto na cor 500 e
 *    texto no tom escuro do mesmo status, em raio inteiro. 24 px na tabela e
 *    28 no cabecalho do detalhe.
 *
 * O MOTIVO NAO MORA AQUI, E ISSO E DE PROPOSITO
 * Ele ja foi `title` deste `<span>`, que nao e focalizavel: nao chegava por
 * teclado, nao chegava por leitor de tela e nao chegava em conferencia
 * impressa. O lugar dele e a segunda linha da celula (p.26), ou uma linha
 * escrita no painel — as duas coisas que a tela desenha ao lado do selo.
 */
export function BadgeStatus({
  status,
  tamanho = 'tabela',
}: {
  readonly status: StatusEquipamento;
  /** `detalhe` e o selo de 28 px do cabecalho do painel de detalhe (p.24, p.28). */
  readonly tamanho?: 'tabela' | 'detalhe';
}) {
  const cores = CORES_DO_STATUS[status];
  const altura = tamanho === 'detalhe' ? 'h-[var(--selo-altura-detalhe)] px-3' : 'h-[var(--selo-altura)] px-2';

  return (
    <span className={`troca-de-status inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-pill ${altura} ${cores.fundo} ${cores.texto}`}>
      <span aria-hidden="true" className={`troca-de-status size-[var(--selo-ponto)] shrink-0 rounded-pill ${cores.ponto}`} />
      <span className="txt-selo">{status}</span>
    </span>
  );
}
